// extracted by mini-css-extract-plugin
export default {"container":"BottomModal_container__t-KOh","modalHeader":"BottomModal_modalHeader__5EkWi","closeIcon":"BottomModal_closeIcon__TMnI0"};